import customFontsApi from '@/api/customFonts'
import { injectCustomFont } from '@/utils/customFont'

const DEFAULT_LIMIT = 20
const DEFAULT_MAX_FILE_SIZE = 5 * 1024 * 1024

const _state = {
  fonts: [],
  limit: DEFAULT_LIMIT,
  maxFileSize: DEFAULT_MAX_FILE_SIZE,
  isLoaded: false,
}

const _getters = {
  uploadedFonts: (state) => state.fonts,
  familyOf: (state) => (token) => {
    const font = state.fonts.find((item) => item.id === token)
    return font ? font.family : null
  },
  isFontListLoaded: (state) => state.isLoaded,
  isLimitReached: (state) => state.fonts.length >= state.limit,
}

/* eslint-disable no-param-reassign */
const mutations = {
  SET_FONTS(state, { fonts, limit, maxFileSize }) {
    state.fonts = fonts
    state.limit = limit || DEFAULT_LIMIT
    state.maxFileSize = maxFileSize || DEFAULT_MAX_FILE_SIZE
    state.isLoaded = true
  },
  ADD_FONT(state, font) {
    state.fonts = [font, ...state.fonts.filter((item) => item.id !== font.id)]
  },
  REMOVE_FONT(state, token) {
    state.fonts = state.fonts.filter((item) => item.id !== token)
  },
}
/* eslint-enable no-param-reassign */

const actions = {
  async fetchFonts({ commit, state }, { force = false } = {}) {
    if (state.isLoaded && !force) return
    try {
      const response = await customFontsApi.list()
      const { fonts = [], limit, maxFileSize } = response.body || {}
      fonts.forEach(injectCustomFont)
      commit('SET_FONTS', { fonts, limit, maxFileSize })
    } catch (error) {
      // leave isLoaded false so the next caller retries
    }
  },
  async uploadFont({ commit }, { file, rightsConfirmed, onProgress }) {
    const response = await customFontsApi.upload({ file, rightsConfirmed, onProgress })
    const { font } = response.body
    injectCustomFont(font)
    commit('ADD_FONT', font)
    return font
  },
  async removeFont({ commit }, token) {
    await customFontsApi.remove(token)
    commit('REMOVE_FONT', token)
  },
}

export default {
  namespaced: true,
  state: _state,
  getters: _getters,
  mutations,
  actions,
}
